import { ElementRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { circle, icon, latLng, marker } from 'leaflet';
import { ConfigService } from '../../services/config/config.service';
import { DateService } from '../../services/date/date.service';
import { SearchService } from '../../services/search/search.service';
import { Business } from '../../services/trucks/truck.model';
import { BingLayerService } from '../../services/bing-layer/bing-layer.service';
var SearchResultTabsComponent = /** @class */ (function () {
    function SearchResultTabsComponent(activatedRoute, searchService, dateService, router, config, bingLayerService, elementRef, ngZone) {
        var _this = this;
        this.activatedRoute = activatedRoute;
        this.searchService = searchService;
        this.dateService = dateService;
        this.router = router;
        this.config = config;
        this.bingLayerService = bingLayerService;
        this.elementRef = elementRef;
        this.ngZone = ngZone;
        this.options = {
            zoom: 18,
            center: latLng(-27.524494, 153.254786)
        };
        this._route = this.activatedRoute;
        this.activatedRoute.queryParams.subscribe(function (params) {
            _this.display = params['display'];
            if (!_this.display || _this.display === '') {
                _this.display = 'list';
            }
            if (_this.display === 'map') {
                _this.createMapLayer(searchService, _this.config);
                var dateGroupParam = params['selectedDateGroup'];
                if (dateGroupParam && searchService.gpsLogDateGroups) {
                    var dateGroup_1 = new Date(dateGroupParam);
                    if (dateGroup_1 instanceof Date) {
                        _this._selectedDateGroup = searchService.gpsLogDateGroups
                            .find(function (dg) { return dg.date.getDate() === dateGroup_1.getDate(); });
                        if (_this._selectedDateGroup) {
                            _this._selectedDateGroup.devices.forEach(function (dvc) {
                                dvc.items.forEach(function (item) {
                                    _this.addTruckMarker(item, params);
                                });
                            });
                        }
                    }
                }
                else {
                    if (searchService.gpsLogItems) {
                        searchService.gpsLogItems.forEach(function (item) {
                            _this.addTruckMarker(item, params);
                        });
                    }
                }
            }
        });
    }
    SearchResultTabsComponent.prototype.selectDateGroup = function (group) {
        this._selectedDateGroup = group;
        this.router.navigate([], {
            relativeTo: this._route,
            queryParams: {
                'selectedDateGroup': group.date
            },
            queryParamsHandling: 'merge'
        });
    };
    Object.defineProperty(SearchResultTabsComponent.prototype, "selectedDateGroup", {
        get: function () {
            return this._selectedDateGroup;
        },
        enumerable: true,
        configurable: true
    });
    SearchResultTabsComponent.prototype.addTruckMarker = function (item, params) {
        if (item.truckNumber) {
            var isSelected = this.isSelectedGpsLog(item, params);
            var mkr = this.createMarker(item, isSelected);
            this.layers.push(mkr);
        }
    };
    SearchResultTabsComponent.prototype.createMapLayer = function (searchService, config) {
        if (this.display === 'map') {
            this.layers = [];
            // center the map on the search results
            this.options.center = latLng(searchService.latitude, searchService.longitude);
            this.layers.push(this.bingLayerService.bingLayer(config.config.bingMapsApiKey, { maxZoom: 19, attribution: 'Bing' }));
            this.layers.push(circle([searchService.latitude, searchService.longitude], { radius: 10 }));
        }
    };
    SearchResultTabsComponent.prototype.createMarker = function (log, isSelected) {
        var _this = this;
        var iconUrl = 'assets/marker.svg';
        if (isSelected) {
            iconUrl = 'assets/marker-selected.svg';
        }
        var mkr = marker([log.latitude, log.longitude], {
            icon: icon({
                iconSize: [25, 41],
                iconAnchor: [13, 41],
                iconUrl: iconUrl,
                shadowUrl: 'assets/marker-shadow.png'
            })
        });
        if (isSelected) {
            mkr.setZIndexOffset(100);
        }
        var popupLink = '<strong>' + this.dateService.momentToClosestMinute(log.timestamp).toISOString(true) + '</strong><br/>';
        popupLink += "<a class=\"createvideorequest\" data-cy=\"create-video-request\">Create video request</a> for " + log.truckNumber;
        mkr.bindPopup(popupLink)
            .on("popupopen", function () {
            _this.elementRef.nativeElement
                .querySelector(".createvideorequest")
                .addEventListener("click", function (e) {
                _this.createVideoRequestFromMap(log);
            });
        });
        return mkr;
    };
    SearchResultTabsComponent.prototype.createVideoRequestFromMap = function (log) {
        var _this = this;
        var address = this.router.routerState.snapshot.root.queryParams['address'];
        var location = address ? address : this.searchService.latitude + ',' + this.searchService.longitude;
        this.ngZone.run(function () {
            _this.router.navigate(['create-video-request', log.truckNumber], {
                queryParams: {
                    computerType: log.computerType,
                    deviceId: log.deviceId,
                    ipAddress: log.ipAddress,
                    location: location,
                    site: _this.searchService.site.siteNumber,
                    softwareVersion: log.softwareVersion,
                    timestamp: _this.dateService.momentToClosestMinute(log.timestamp).format(),
                    business: Business[log.business],
                }
            });
        });
    };
    SearchResultTabsComponent.prototype.isSelectedGpsLog = function (log, params) {
        return log.truckNumber === params['truckNumber'] &&
            log.computerType === params['computerType'] &&
            log.deviceId === params['deviceId'] &&
            log.ipAddress === params['ipAddress'] &&
            log.softwareVersion.toString() === params['softwareVersion'] &&
            this.dateService.momentToClosestMinute(log.timestamp).format() === params['timestamp'];
    };
    return SearchResultTabsComponent;
}());
export { SearchResultTabsComponent };
